import React, { Component } from 'react'
import { MuiGrid, MuiIconButton, MuiClear, MuiTypography, MuiEdit } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import { WeeklyAvailabilityScheduleUtil } from '../../weeklyAvailability';
import AlertDialogComponent from '../teacher/AlertDialogComponent';

export class AddRowComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggleChange: false,
      showDeleteConfirmDialog: false,
      errorMessage: undefined,
      displayStringForWeeklyAvailability: undefined
    }
  }

  componentWillMount() {
    if (this.props.room.weeklyAvailability.availableForAllHours !== "true" && this.props.room.weeklyAvailability.availableForAllHours !== true) {
      this.props.room.weeklyAvailability.availableForAllHours = "false"
      let weeklyAvailabilitySchedule = WeeklyAvailabilityScheduleUtil.destructorOfWeeklyAvailabilitySchedule(this.props.room.weeklyAvailability)
      let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(weeklyAvailabilitySchedule)
      this.props.room.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList
    }

    if (this.props.room.weeklyAvailabilityDisplayList != undefined
      && this.props.room.weeklyAvailabilityDisplayList.length > 0) {
      let weeklyAvailabilityDisplayList = this.props.room.weeklyAvailabilityDisplayList
      let displayStringForWeeklyAvailability = weeklyAvailabilityDisplayList.toString();
      this.setState({
        displayStringForWeeklyAvailability: displayStringForWeeklyAvailability
      })
    }
  }

  onClickOfDeleteGrade = () => {
    const i18n = this.props.i18n
    this.setState({
      showDeleteConfirmDialog: true,
      errorMessage: i18n.requiredSharedRoom.deletingSharedRoom
    });
  }

  handeleDeleteGrade = () => {
    let key = this.props.index
    this.props.handleDelete(this.props.selectedRoom)
    this.setState({ showDeleteConfirmDialog: false });

  }

  handleCloseDialog = () => {
    this.setState({ showDeleteConfirmDialog: false });
  }

  render() {
    return (
      <MuiGrid container xs={12} direction='row' >
        <MuiGrid item xs={2} container style={theme.gridTableStyleForSharedRoomMasterData}>
          <MuiTypography id='name'  >
            {this.props.room.name} ({this.props.room.roomCount})
                  </MuiTypography>
        </MuiGrid>
        <MuiGrid item xs={1} container style={theme.gridTableStyleForSharedRoomMasterData} >
          <MuiTypography id='name'  >
            {this.props.room.roomCode}
          </MuiTypography>
        </MuiGrid>

        < MuiGrid item xs={3} container style={theme.gridTableStyleForSharedRoomMasterData}>
          <MuiTypography id='description' >
            {this.props.room.description}
          </MuiTypography>
        </MuiGrid>
        < MuiGrid container direction="row" xs alignItems='center' style={theme.gridTableBeforeEditStyle} >
          <MuiGrid container xs={12} >
            {this.state.displayStringForWeeklyAvailability != undefined
              &&
              <MuiGrid item xs={12}   >
                <MuiTypography variant="subtitle2"> {this.state.displayStringForWeeklyAvailability}</MuiTypography>
              </MuiGrid>
            }
          </MuiGrid>

        </MuiGrid>
        < MuiGrid item style={theme.gridTableEditStyle} align='right' >
          <MuiIconButton id="editButton" onClick={() => this.props.onClickOfEditRoom(this.props.room, this.props.selectedRoom)} >
            < MuiEdit style={{ color: theme.palette.grey.dark }} />
          </MuiIconButton>
        </MuiGrid>
        < MuiGrid item style={theme.gridTableClearButtonStyle} justify="center " alignContent="center">
          <MuiIconButton onClick={() => this.onClickOfDeleteGrade()} id="delete">
            <MuiClear style={{ color: theme.palette.grey.dark }} />
          </MuiIconButton>
        </ MuiGrid>

        {this.state.showDeleteConfirmDialog &&
          <AlertDialogComponent
            {...this.props}
            errorMessage={this.state.errorMessage}
            openDialog={this.state.showDeleteConfirmDialog}
            handleCloseDialog={this.handleCloseDialog}
            handleClickOnYes={this.handeleDeleteGrade}

          />
        }

      </MuiGrid>
    )
  }
}

export default AddRowComponent
